import TickClass from 'lib/TickClass';

/**
 * Monitors mouse activity to determine whether the user is actively engaged
 */
class ScrollActivity extends TickClass {
  /**
   * @param  {object} config - configuration object to set specific settings in the instance
   * @param {object} ...params - object of the rest of the parameters to easily pass to
   * super consturctor
   */
  constructor(config, ...params) {
    super(config, ...params);

    this.setupEventListeners = this.setupEventListeners.bind(this);
    this.resetIdle = this.resetIdle.bind(this);
    this.tick = this.tick.bind(this);
    this.releaseEventListeners = this.releaseEventListeners.bind(this);
    this.browserScroll = this.browserScroll.bind(this);

    this._config = {
      tolerance: 10,
      ...this._config,
      ...config,
    };

    this._scrollActiveState = true;
    this._scrollIdleTime = 0;

    this.setupEventListeners();
  }

  /**
   * Setup event listeners that trigger active state changes
   * @private
   */
  setupEventListeners() {
    document.addEventListener('scroll', this.browserScroll);
  }

  /**
   * Release event listeners that trigger active state changes
   * @private
   */
  releaseEventListeners() {
    document.removeEventListeners('scroll', this.browserScroll);
  }

  /**
   * Increments the idle time every X milliseconds
   * @private
   */
  tick() {
    this._scrollIdleTime += 1;

    if (this._scrollActiveState && (this._scrollIdleTime >= this._config.tolerance)) {
      this._scrollActiveState = false;
      this.dispatchEvent('statechange', false);
    }
  }

  /**
   * Callback for scroll event listener
   * @private
   */
  browserScroll() {
    this._scrollIdleTime = 0;
    if (!this._scrollActiveState) {
      this._scrollActiveState = true;
      this.dispatchEvent('statechange', true);
    }
  }

  /**
   * Resets the idle to 0 or a specified number
   * @param  {Number} buffer - an optional number to set the idle to
   */
  resetIdle(buffer = 0) {
    this._scrollIdleTime = buffer;
  }

  /**
   * Get the current active state of the activity
   * @return {boolean}
   */
  get active() {
    return this._scrollActiveState;
  }

  /**
   * Cleanup any event listeners and variable references so it can be cleanly released
   * @param  {...Object} params - any unloading params that might be passed to super's
   * unload function
   */
  unload(...params) {
    this.releaseEventListeners();
    super.unload(...params);
  }
}

export default ScrollActivity;
